import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gamla /spotpriser/<omrade> – permanent omdirigering. */
export const Route = createFileRoute("/spotpriser/$area")({
  head: () => seoHead("/spotpriser/$area"),
  beforeLoad: ({ params }) => {
    const a = (params.area ?? "se3").toLowerCase();
    permanentRedirect(`/spotpris/elomrade-${a.startsWith("se") ? a : `se${a}`}`);
  },
});
